<template>
  <v-container fluid class="mx-0 px-0" @keydown.enter="submit()">
    <template v-if="showError">
      <v-row>
        <v-col cols="12">
          <v-alert dense outlined type="error" class="my-0">
            <span v-html="errorMessage"></span>
          </v-alert>
        </v-col>
      </v-row>
    </template>
    <v-row>
      <v-col cols="9" v-if="showPaieska">
        <el-text-field
          label="Notarinio įgaliojimo numeris"
          :tooltip="`${pazymaTooltipPrefix} Notarinio įgaliojimo numeris`"
          autofocus
          v-model="notarinio_registro_nr"
          @focus="focusRegistroNr"
          @blur="blurRegistroNr"
        />
      </v-col>
      <v-col cols="3" class="text-right" v-if="showPaieska">
        <el-button
          class="mt-4"
          primary
          @click.native="checkIgaliojimasRegistras()"
          :loading="loading"
          :disabled="disabledIeskoti"
          small
        >
          Tikrinti registre
        </el-button>
      </v-col>
      <v-col cols="12" v-if="showIgaliojimasNotaro">
        <v-data-table
          :headers="headers"
          :items="igaliojimai"
          :loading="loading"
          :hide-default-footer="true"
          :hide-default-header="true"
        >
          <template #[`item.actions`]="{ item }">
            <el-table-action
              :item="item"
              @deleteItem="deleteIgaliojimas(item)"
            />
          </template>
          <template slot="no-data">-</template>
          <template slot="loading">Kraunasi...</template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PazymaMap from '../PazymaMap'

export default {
  name: 'IgaliojimasNotaras',
  props: {
    value: String,
    readonly: Boolean,
    foreign: { type: Boolean, default: false },
    pazyma: Object,
    asmKodas: String,
    autofocus: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: false,
      notarinio_registro_nr: null,
      loadingRegistras: false,
      showError: false,
      errorMessage: null,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Pavadinimas',
          align: 'start',
          value: 'igaliojimas',
        },
        {
          text: 'Veiksmai',
          align: 'right',
          value: 'actions',
          width: 80,
          cellClass: 'actions',
        },
      ]
    },
    igaliojimas: {
      get() {
        return this.value
      },
      set(elValue) {
        this.$emit('input', elValue)
      },
    },
    isReadonly() {
      return this.readonly
    },
    showPaieska() {
      return !this.isReadonly && !this.foreign && !this.showIgaliojimasNotaro
    },
    disabledIeskoti() {
      return !this.notarinio_registro_nr
    },
    autoGrow() {
      return this.isReadonly
    },
    pazymaMap() {
      return PazymaMap.getPazymaTipas(this.pazyma?.paz_tipas)
    },
    pazymaTooltipPrefix() {
      return this.pazymaMap.tooltipPrefix
    },
    igaliojimasReadonly() {
      return this.isReadonly
    },
    igaliojimasRows() {
      return this.igaliojimasReadonly ? 0 : 3
    },
    igaliojimai() {
      if (!this.pazyma?.paz_igaliojimai) {
        return null
      }
      return [
        {
          id: this.pazyma.paz_igaliojimai.id,
          igaliojimas: this.pazyma.paz_igaliojimai.igaliojimas,
          canDelete: !this.pazyma.paz_readonly,
        },
      ]
    },
    pazymaId() {
      return this.pazyma?.paz_id
    },
    igaliojimasNotaro() {
      return this.pazyma?.paz_igaliojimas
    },
    showIgaliojimasNotaro() {
      return this.igaliojimai
    },
  },
  created() {
    this.$emit('loaded')
  },
  methods: {
    resetError() {
      this.errorMessage = null
      this.showError = false
    },
    checkIgaliojimasRegistras() {
      this.loading = true
      this.resetError()
      this.$emit('isLoading')

      const data = {
        paz_id: this.pazymaId,
        asm_kodas: this.asmKodas,
        notarinio_registro_nr: this.notarinio_registro_nr,
      }

      this.$axios
        .post(`ntrpaslaugos/pazyma/${this.pazymaId}/igaliojimai/notaras`, data)
        .then(res => {
          // window._VMA.$emit('DATA_OK', res.data.message)
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.errorMessage = err.response.data.message
            this.showError = true
            return
          }
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.$emit('loaded')
          this.$emit('updatePazyma')
        })
    },
    deleteIgaliojimas() {
      this.loading = true
      this.$emit('isLoading')

      this.$axios
        .delete(`ntrpaslaugos/pazyma/${this.pazymaId}/igaliojimai`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.igaliojimas = null
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.$emit('loaded')
          this.$emit('updatePazyma')
        })
    },
    submit() {
      if (!this.loading && !this.disabledIeskoti) {
        this.checkIgaliojimasRegistras()
      }
    },
    focusRegistroNr() {
      this.$emit('disableSave', true)
    },
    blurRegistroNr() {
      this.$emit('disableSave', false)
    },
  },
}
</script>

<style lang="scss" scoped>
.igaliojimas-div {
  max-height: 100px;
}
.actions {
  width: 80px;
}
</style>
